import { Component, HostListener, Inject, OnInit, TemplateRef, ViewChild, DOCUMENT } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { debounceTime, distinctUntilChanged } from 'rxjs';
import { AiSourcingHandlerService } from 'src/app/_services/ai-sourcing-handler.service';
import { AiSourcingService } from 'src/app/_services/ai-sourcing.service';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
import { TransactionService } from 'src/app/_services/transaction.service';
import { ShareProjectComponent } from '../share-project/share-project.component';

import { PersonSearchService } from 'src/app/_services/person-search.service';
declare const clevertap;

@Component({
    selector: 'app-project-list',
    templateUrl: './project-list.component.html',
    styleUrls: ['./project-list.component.scss'],
    standalone: false
})
export class ProjectListComponent implements OnInit {

  @ViewChild('renameProjectModel') renameProjectModel: TemplateRef<any>;

  ProjectList: any[] = [];
  tableData = [
  {
    name: 'Software Engineer',
    pipelineCount: 15,
    recommended: 'Available',
    status: 'private',
    lastUpdate: '2026-07-20',
    owner:'Anjali Puthran'
  },
  {
    name: 'Product Manager',
    pipelineCount: 23,
    recommended: 'Not Available',
    status: 'shared',
    lastUpdate: '2026-07-18',
    owner:'Sonu Prasad'

  },
  {
    name: 'UX Designer',
    pipelineCount: 18,
    recommended: 'Available',
    status: 'shared',
    lastUpdate: '2026-07-19',
    owner:'Bhavya Parikh'

  }
];
  searchInput: UntypedFormControl = new UntypedFormControl(null);
  typeAheadData: any[] = [];

  /** Pagination handler */
  start: number = 0;
  limit: number = 10;
  currentPage: number = 1;
  pageSize: number = 10;
  totalCount: number = 0;
  profilesPerPage: number = 10;

  successMessage: String = '';
  errorMessage: String = '';
  showSpinnerLoader: Boolean = false;

  /** Regex to check valid project name */
  inputRegex = /^[a-zA-Z0-9\-'\.,@&\/\+\:\#_\(\)\"\'\* ]*$/;

/** Handler rename project */
  renameProjectInput: UntypedFormControl = new UntypedFormControl(null);
  renameProjectInputError: Boolean = false;
  renameProjectInputSpecialCharError: Boolean = false;
  selectedRenameProject: any;
  dublicateProjectNameError: boolean = false;

  /** Handle for EU access */
  haseuaisourcingaccess: number = 0;
  disableProject: boolean = true;
  infoMessage: string = '';
  isteamAdmin: boolean = false;
  isAISourcingEnabled: boolean = false;
  autopilotprojectslots: number = 0;
  activeProjectCount: number = 0;
  showLoaderForProjectList: boolean = false;
  projectSearchedByname: boolean = false;

  /**project Listing Sorting*/
  radioBtnFilter: string = 'updatedon_desc';
  SortByUpdatedon: string = '';
  SortByProjectName: string = '';
  isScrolled: boolean = false;
  private readonly scrollThreshold = 55;
  @HostListener('window:scroll', ['$event'])
  onWindowScroll() {
    const verticalOffset = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
    this.isScrolled = verticalOffset >= this.scrollThreshold;
  };

  constructor(
    private modelService: NgbModal,
    private router: Router,
    private aiSourcingService: AiSourcingService,
    private aiSourcingHandlerService: AiSourcingHandlerService,
    private localstorageservice: LocalStorageService,
    private transactionService: TransactionService,
    private personSearchService: PersonSearchService,
    @Inject(DOCUMENT) private document: Document
  ) { }

  ngOnInit() {
    const preferenceArray = this.localstorageservice.getItem('userdata').preferenceData;
    preferenceArray && preferenceArray.length && preferenceArray.map(item => {
      if (item.listing_type == 'project-listing' && item.preference_type == 'page-size') {
        this.profilesPerPage = item.preference_value;
      }
    })

    this.getCurrentPlanDetails();
    this.getProjectList();
    this.isteamAdmin = this.localstorageservice.getItem('role')!='teammember' ? true : false;
    this.isAISourcingEnabled = this.localstorageservice.getItem('autopilotslotaccess') == '1' ? true : false;
    this.renameProjectInput.valueChanges.pipe(debounceTime(300), distinctUntilChanged()).subscribe((value: any) => {
      if (value && value.length > 0 && !this.inputRegex.test(value)) {
        this.renameProjectInputSpecialCharError = true;
      } else {
        this.renameProjectInputSpecialCharError = false;
      }
      this.getDuplicateProjectNameError(value);
      this.renameProjectInputError = false;
    });

    this.searchInput.valueChanges.subscribe((value: any) => {
      if (value && value.trim()) {
        this.projectSearchedByname = true;
        this.getProjectList(value);
      } else {
        this.projectSearchedByname = false;
        this.getProjectList(null);
      }
      this.start = 0;
      this.limit = 10;
    });

  };

  /**
   * Method to check if the project name already exists.
   * @param projectName
   */
  getDuplicateProjectNameError(projectName: string) {
    this.aiSourcingService.isDuplicateProjectName(projectName).subscribe((response: any) => {
      if (response && response.status == 'success') {
        if (response && response.duplicate) {
          this.dublicateProjectNameError = true;
        } else {
          this.dublicateProjectNameError = false;
        }
      } else {
        this.dublicateProjectNameError = false;
      }
    })
  };

  /**
   * Method to fetch all the project
   */
  getProjectList(projectname: string = null) {
    this.showLoaderForProjectList = true;
    this.aiSourcingService.getProjectList(this.start, this.profilesPerPage, projectname, this.SortByUpdatedon, this.SortByProjectName).subscribe((response: any) => {
      if (response && response.status == 'success') {
        this.totalCount = response.totalprojectcount;
        this.ProjectList = response.data;
        this.activeProjectCount = response.activatedprojectcount;
        this.autopilotprojectslots = response.projectslots;
        this.showLoaderForProjectList = false;
       } else {
        this.showLoaderForProjectList = false;
        this.ProjectList = [];
      }
    })
  };

  /**
   * Methos to fetch user current plan
   */
  getCurrentPlanDetails() {
    // Access refresh for this route is handled by AccessRefreshGuard (canActivate on ai-sourcing,
    // see app-routing.module.ts) - reads the already-loaded signal instead of calling the API again.
    this.haseuaisourcingaccess = this.transactionService.access()?.haseuaisourcingaccess ?? 0;
  };

  /**
   * Method to use disable project list as per EU Access
   * @param project
   * @returns
   */
  euAccessProjectHandler(project: any) {
    if (project?.iseuproject && !this.haseuaisourcingaccess) {
      return true;
    } else {
      return false;
    }
  };

  /**
   * Method to use pagination
   * @param index
   */
  onPageChange(index: number) {
    if(this.projectSearchedByname) return;
    this.start = (index - 1) * this.pageSize;
    this.currentPage = index;
    this.getProjectList();
  };


  /**
   * Method to create a new project.
   */
  createproject() {
    this.localstorageservice.clearItem('parshedJD');
    this.aiSourcingHandlerService.setDisplayPageEvent('jd-page');
    this.router.navigate(['/ai-sourcing/jd-description']);
    /**
     * Create Project
     */
         const createProjectParams = {
          "User ID": this.localstorageservice.getItem('userdata').userid,
        }
        clevertap.event.push("Autopilot-Create Project",createProjectParams);
  }

  /**
   * Method to handle the renaming of a project.
   */
  openRenameProjectModel(project: any) {
    this.selectedRenameProject = project;
    this.renameProjectInput.setValue(project?.projectname ? project?.projectname : null);
    this.modelService.open(this.renameProjectModel, { size: 'xs' as 'lg', centered: true, backdrop: 'static', keyboard: false });
  };

  /**
   * Rename project name
   * @returns
   */
  renameProject() {
    if ((!this.renameProjectInput.value && !this.selectedRenameProject?.projectnumber) || this.renameProjectInputSpecialCharError) return;
    this.showSpinnerLoader = true;
    const projectName = {
      projectname: this.renameProjectInput.value.trim()
    };
    const projectNumber = this.selectedRenameProject?.projectnumber;

    this.aiSourcingService.renameProject(projectNumber, projectName).subscribe((res: any) => {
      if (res && res.body && res.body.status == 'success') {
        this.successMessage = res.body.message;
        this.getProjectList();
        this.renameProjectInput.setValue(null);
        this.renameProjectInputError = false;
        this.selectedRenameProject = null;
        setTimeout(() => this.successMessage = '', 5000);
      } else {
        this.errorMessage = res.body.message;
        setTimeout(() => this.errorMessage = '', 5000);
      }
      this.dismiss();
      this.showSpinnerLoader = false;
    }, (err) => {
       this.errorMessage = err.error.message;
      setTimeout(() => this.errorMessage = '', 5000);
      this.showSpinnerLoader = false;
    })
  }

  /**
   * Method to redirect project details
   * @param project
   */
  projectDetails(project: any) {
    if(project?.status == 'inactive') {
      if(project?.aisourcingstatus == 'started' && project?.shortlistedcount == 0) {
        this.aiSourcingHandlerService.setDisplayPageEvent('insights');
        this.router.navigate([`/ai-sourcing/ai-sourcing-insights/${project.projectnumber}`]);
      } else {
         this.aiSourcingHandlerService.setDisplayPageEvent('shortlist');
      this.router.navigate([`/ai-sourcing/ai-sourcing-profiles/shortlist/${project.projectnumber}`]);
    }
    }
    else if (project?.aisourcingstatus == 'started' && (project?.shortlistedcount > 0)) {
        this.aiSourcingHandlerService.setDisplayPageEvent('review');
        this.router.navigate([`/ai-sourcing/ai-sourcing-profiles/review/${project.projectnumber}`]);
     } else if (project?.aisourcingstatus == 'started' && project?.shortlistedcount == 0) {
      this.aiSourcingHandlerService.setDisplayPageEvent('insights');
      this.router.navigate([`/ai-sourcing/ai-sourcing-insights/${project.projectnumber}`]);
    } else if (project?.aisourcingstatus == 'completed' && (project?.unactionedcount > 0 || project?.shortlistedcount > 0)) {
      this.aiSourcingHandlerService.setDisplayPageEvent('review');
      this.router.navigate([`/ai-sourcing/ai-sourcing-profiles/review/${project.projectnumber}`]);
    } else {
      this.router.navigate([`/ai-sourcing/project-details/${project.projectnumber}`]);
    };
  };

  /**
   * Method to handle the dismissal of the project list component.
   */
  dismiss() {
    this.modelService.dismissAll();
    this.showSpinnerLoader = false;
  }

  changeProjectStatus(project: any, status: string) {
    this.showSpinnerLoader = true;
    const payload = {
      projectnumber: project.projectnumber,
      status: status
    }
    this.aiSourcingService.changeProjectStatus(payload).subscribe((res: any) => {
      if (res && res.status == 'success') {
        this.successMessage = res.message;
        this.getProjectList();
        setTimeout(() => this.successMessage = '', 5000);
      } else {
        this.errorMessage = res.message;
        setTimeout(() => this.errorMessage = '', 5000);
      }
    }, (err)=>{
      this.errorMessage ="You have already used all your project slots. Please upgrade your plan to create more projects.";
      setTimeout(() => this.errorMessage = '', 5000);
    })
  }

  get isButtonDisabled() {
  return this.autopilotprojectslots
      && (this.activeProjectCount >= this.autopilotprojectslots) ;
}

  shareProject(project: any) {
   const modalRef =  this.modelService.open(ShareProjectComponent, { size: 'lg', centered: true, backdrop: 'static', keyboard: false });
   modalRef.componentInstance.selectedProject = project;
    modalRef.result
    .then((res: any) => {
      if(res === 'user-dismissed') return;
      this.successMessage = res;
    })
    .catch((err: any) => {
      this.errorMessage = err;
    })
    .finally(() => {
      setTimeout(() => {
        this.successMessage = '';
        this.errorMessage = '';
      }, 5000);
    });
  }

  /**
   * Method to clone a project
   * @param project
   */
  cloneProject(project: any) {
    this.localstorageservice.clearItem('parshedJD');
    this.aiSourcingHandlerService.setDisplayPageEvent('jd-page');
    this.router.navigate([`/ai-sourcing/jd-description/${project?.projectnumber}`]);
  };

  /**
   * Handle radio button filter for candidate listing
   * @param event
   */
  onFilterChange(event: any) {
    const selectedFilterInput = event.target.value;

    switch (selectedFilterInput) {
      case 'updatedon_desc':
        this.radioBtnFilter = selectedFilterInput;
        this.SortByUpdatedon = 'desc';
        this.SortByProjectName = '';
        break;

      case 'updatedon_asc':
        this.radioBtnFilter = selectedFilterInput;
        this.SortByUpdatedon = 'asc';
        this.SortByProjectName = '';
        break;

      case 'projectname_desc':
        this.radioBtnFilter = selectedFilterInput;
        this.SortByUpdatedon = '';
        this.SortByProjectName = 'desc';
        break;

      case 'projectname_asc':
        this.radioBtnFilter = selectedFilterInput;
        this.SortByUpdatedon = '';
        this.SortByProjectName = 'asc';
        break;

      default:
        this.radioBtnFilter = selectedFilterInput;
        this.SortByUpdatedon = '';
        this.SortByProjectName = '';
        break;

    };

    this.start = 0;
    this.limit = 10;
    this.currentPage = 1;
    this.getProjectList(this.searchInput.value?.trim());
  };

  toastmessage(message: string, type: string) {
    if (type == 'success') {
      this.successMessage = message;
      setTimeout(() => this.successMessage = '', 5000);
    } else if (type == 'error')
      this.errorMessage = message;
    setTimeout(() => this.errorMessage = '', 5000);
  };

  setPage(index: number) {
    if (this.projectSearchedByname) return;
    this.start = (index - 1) * Number(this.profilesPerPage);
    if (index == 1) this.currentPage = 1;
    this.getProjectList();
    this.document.documentElement.scrollTop = 0;
  };

  /**
  * Used to change number of profiles on each page
  */
  updatePagePreference() {
    const data = {
      preference_type: 'page-size',
      preference_value: this.profilesPerPage,
      listing_type: 'project-listing'
    }

    try {
      this.personSearchService.updatePagePreference(data);
      this.setPage(1);
    } catch {
      this.toastmessage("Something went wrong", 'error');
    }
  }

}
